import { useDevice } from "../../../useDevice";
import Box from "../../Box";
import { AppLogo } from "../AppLogo";
import type { Logo } from "../types";

type Props = {
	logo: Logo;
	isCollapsed: boolean;
	renderFab?: () => React.ReactNode;
	onPressLogo?: () => void;
};

export const LogoSection = ({
	logo,
	isCollapsed,
	renderFab,
	onPressLogo,
}: Props) => {
	const { isShortScreen } = useDevice();
	return (
		<Box gap={isShortScreen ? 16 : 28}>
			<AppLogo
				logo={logo}
				variant={isCollapsed ? "stacked" : "default"}
				onPress={onPressLogo}
				accessibilityLabel="Go to home"
				contentPosition={isCollapsed ? "center" : "left"}
				transition={400}
				containerStyle={{
					width: isCollapsed ? 48 : "60%",
					height: isCollapsed ? 48 : 36,
				}}
			/>
			{renderFab && (
				<Box alignItems={isCollapsed ? "center" : "flex-start"} gap={6}>
					{renderFab()}
				</Box>
			)}
		</Box>
	);
};
